import React, { useContext } from 'react';
import makeStyles from './styles';
import SuccessImage from '../../../assets/images/my-deposits/success.png';
import FailureImage from '../../../assets/images/my-deposits/failed.png';
import { PhrasesContext } from '../../../context/PhrasesContext';
import { useIntl } from 'react-intl';

import { Avatar, Button, useMediaQuery } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTheme } from '@material-ui/styles';
const ResponseInquery = ({ changeModal, response }) => {
	const classes = makeStyles();
	const theme = useTheme();

	const locale = useIntl().locale;
	const [phrases] = useContext(PhrasesContext);

	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const isSmallExtraScreen = useMediaQuery(theme.breakpoints.down('xs'));

	const renderSuccessModal = () => (
		<div className={classes.modalContainer}>
			<img className={classes.imgResponse} src={SuccessImage} />
			<div className={classes.text}>
				<p
					className={classes.subHeaderMessage}
					style={{ marginTop: '30px', width: '250px' }}
				>
					{phrases['lblMessageSuccessTxt']?.[locale]}
				</p>
			</div>

			<div>
				<Button
					variant="contained"
					className={classes.btnPrimary}
					onClick={() => changeModal()}
				>
					{phrases['btnDoneDeliveryLocation']?.[locale]}
				</Button>
			</div>
		</div>
	);

	const renderFailureModal = () => (
		<div className={classes.modalContainer}>
			<img className={classes.imgResponse} src={FailureImage} />
			<div className={classes.text}>
				<p className={classes.subHeaderMessage} style={{ marginTop: '30px' }}>
					Your message wasn't delivered
				</p>
				<p className={classes.subHeaderMessage}>due to some reason.</p>
			</div>

			<div>
				<Button
					variant="contained"
					className={classes.btnPrimary}
					onClick={() => changeModal()}
				>
					Try Again
				</Button>
			</div>
		</div>
	);

	return (
		<div className={classes.modal}>
			<div className={classes.boxContainer}>
				<div className={classes.iconContainer}>
					<CloseIcon
						className={classes.closeIcon}
						style={{
							color: '#ff422f',
							margin: '5px',
							position: 'relative',
							top: '15px',
							left: locale == 'en' ? '-12px' : '12px',
							cursor: 'pointer',
							width: '22px',

							// color: rgb(255, 66, 47);
							// margin: 5px;
							// position: relative;
							// top: 15px;
							// left: -12px;
							// cursor: pointer;
							// width: 22px;
						}}
						onClick={() => changeModal()}
					/>
				</div>

				{response === 'SUCCESS_RESPONSE'
					? renderSuccessModal()
					: renderFailureModal()}
			</div>
		</div>
	);
};

export default ResponseInquery;
